// Thin host wrapper — Tournament Hub (Groups / Calendar / Bracket /
// DNA Roster). Match/standings tables are a future C-phase migration;
// the hook degrades to empty so the page shows its honest-empty state.
import { useParams, useNavigate } from "react-router-dom";
import { useIntlAccaHub } from "../../intl-acca/useIntlAccaHub.ts";
import { TournamentHubPage } from "./TournamentHubPage.tsx";

export function IntlAccaHubRoute(): JSX.Element {
  const { tournamentId = "" } = useParams();
  const navigate = useNavigate();
  const vm = useIntlAccaHub(tournamentId);
  return (
    <TournamentHubPage
      loading={vm.loading}
      error={vm.error}
      tournament={vm.tournament}
      groups={vm.groups}
      matches={vm.matches}
      nations={vm.nations}
      participatingNations={vm.participatingNations}
      bracket={vm.bracket}
      onTeamClick={(teamCode) =>
        navigate(`/intl-acca/${tournamentId}/dna/${teamCode}`)}
      onFixtureClick={() => navigate(`/intl-acca/${tournamentId}`)}
    />
  );
}
